export const initialXMin: number = 261065;
export const initialYMin: number = 6646922;
export const initialXMax: number = 265265;
export const initialYMax: number = 6650122;
export const wkid: number = 25833;
export const webmapid: string = "23466fbbab484d09af8b4e97ddb6ecc9";
export const webmapidempty: string = "4811f7dae76c424aa194a95e5df9a785";
